import React from 'react';
import NodeSymbolSelect from './NodeSymbolSelect';
import { Handle, Position } from 'reactflow';

const boxStyle = {
  padding: 12, borderRadius: 8, border: '2px solid #64748b',
  background: 'var(--card)', minWidth: 220, fontSize: 13, color: 'var(--text)',
};
const selStyle = {
  width: '100%', marginBottom: 6, padding: 4, background: 'var(--surface)',
  color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4,
};
const rowStyle = { display: 'flex', gap: 6, marginBottom: 6 };

export default function SessionRangeNode({ data, id }) {
  const onChange = (field, value) => {
    if (data.onChange) data.onChange(id, field, value);
  };
  const session = data.session || 'london';
  return (
    <div style={boxStyle}>
      <div style={{ fontWeight: 700, marginBottom: 8, color: '#94a3b8' }}>🗓 Session Range</div>
      <NodeSymbolSelect value={data.symbol} onChange={(v) => onChange('symbol', v)} />

      <select value={session} onChange={(e) => onChange('session', e.target.value)} style={selStyle}>
        <option value="london">London (08:00–16:30 UTC)</option>
        <option value="us_open">New York (13:30–20:00 UTC)</option>
        <option value="asia">Asia / Tokyo (00:00–08:00 UTC)</option>
        <option value="custom">Custom range…</option>
      </select>

      {session === 'custom' && (
        <div style={rowStyle}>
          <div style={{ flex: 1 }}>
            <label style={{ fontSize: 11, color: 'var(--muted)' }}>Start (UTC)</label>
            <input type="text" placeholder="13:30" value={data.start ?? '13:30'}
              onChange={(e) => onChange('start', e.target.value)} style={{ ...selStyle, marginBottom: 0 }} />
          </div>
          <div style={{ flex: 1 }}>
            <label style={{ fontSize: 11, color: 'var(--muted)' }}>End (UTC)</label>
            <input type="text" placeholder="14:00" value={data.end ?? '14:00'}
              onChange={(e) => onChange('end', e.target.value)} style={{ ...selStyle, marginBottom: 0 }} />
          </div>
        </div>
      )}

      <select value={data.which || 'high'} onChange={(e) => onChange('which', e.target.value)} style={selStyle}>
        <option value="high">Session High</option>
        <option value="low">Session Low</option>
      </select>

      <div style={rowStyle}>
        <div style={{ flex: 1 }}>
          <label style={{ fontSize: 11, color: 'var(--muted)' }}>Days back</label>
          <input type="number" min={0} max={30} value={data.days_back ?? 0}
            onChange={(e) => onChange('days_back', Math.max(0, Math.min(30, parseInt(e.target.value, 10) || 0)))}
            style={{ ...selStyle, marginBottom: 0 }} />
        </div>
        <div style={{ flex: 1 }}>
          <label style={{ fontSize: 11, color: 'var(--muted)' }}>Combine days</label>
          <input type="number" min={1} max={30} value={data.span ?? 1}
            onChange={(e) => onChange('span', Math.max(1, Math.min(30, parseInt(e.target.value, 10) || 1)))}
            style={{ ...selStyle, marginBottom: 0 }} />
        </div>
      </div>

      <div style={{ marginTop: 2, fontSize: 10, color: 'var(--muted)' }}>
        Intraday only. Outputs the session's frozen high/low as a price level —
        compare against price for opening-range / session breakouts. Days back 0 = today,
        1 = yesterday; combine 3 = highest high / lowest low across 3 sessions.
      </div>

      <Handle type="source" position={Position.Right} id="output" style={{ background: '#64748b' }} />
    </div>
  );
}
